export default __webpack_public_path__ + "static/media/fullCycle.99716d27.png";